// extracted by mini-css-extract-plugin
export default {"mainContainer":"Styles_mainContainer__odRWC","slider1":"Styles_slider1__ZAJ0E","slider2":"Styles_slider2__Z972K","submittedForm":"Styles_submittedForm__jt2E8"};